import { formatDate } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Client } from '../../../../../../projects/kiene-core/src/lib/components/client/classes/client';
import { API_BASE_URL_SERVICE } from '../../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneTableService } from '../../../../components/kiene-table/kiene-table.service';
import { MessageService } from '../../../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { KieneUtils } from '../../../../../../projects/kiene-core/src/lib/utils/KieneUtils';
import { Gruppe } from './../../../../../../projects/kiene-core/src/lib/components/gruppen/classes/gruppe';

@Component({
    selector: 'kiene-gruppe-edit-dialog',
    templateUrl: './gruppe-edit-dialog.component.html',
    styleUrls: ['./gruppe-edit-dialog.component.css'],
})
export class GruppeEditDialogComponent implements OnInit {
    protected readonly KieneUtils = KieneUtils;

    gruppe = new Gruppe();

    // Anzahl tiere entweder durch csv hochgeladen oder ueber HIT gemeldet
    anzahlTiereOhrmarke = 0;

    nameCtrl = new UntypedFormControl();
    standortParams = new HttpParams();
    standort = '';
    client: Client;

    aufstalleinheitJahrCtrl = new UntypedFormControl();
    aufstalleinheitNummerCtrl = new UntypedFormControl();

    // lieferantenVVVOCtrl = new FormControl();
    einstalldatumVonCtrl = new UntypedFormControl();
    einstalldatumBisCtrl = new UntypedFormControl();
    anzahlTiereCtrl = new UntypedFormControl();
    alterEinstallungCtrl = new UntypedFormControl();

    constructor(
        public dialogRef: MatDialogRef<GruppeEditDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private api: KieneTableService,
        private messageService: MessageService,
    ) {
        if (this.data && this.data.gruppe) {
            this.gruppe = this.data.gruppe;
            this.standortParams = this.standortParams.set('kunde_id', this.gruppe.kunde_id.toString());
        }
    }

    ngOnInit(): void {
        this.loadClient();

        this.nameCtrl.setValue(this.gruppe.bezeichnung);

        this.standort = this.gruppe.stall;
        // this.lieferantenVVVOCtrl.setValue(this.gruppe.lieferant_vvvo);
        this.einstalldatumVonCtrl.setValue(this.parseApiDate(this.gruppe.einstalldatum_von));
        this.einstalldatumBisCtrl.setValue(this.parseApiDate(this.gruppe.einstalldatum_bis));
        this.anzahlTiereCtrl.setValue(this.gruppe.anzahl_tiere);
        this.alterEinstallungCtrl.setValue(this.gruppe.alter_bei_einstallung);
    }

    close() {
        this.dialogRef.close(null);
    }

    setStandort(standort: any) {
        if (typeof standort === 'string') {
            this.standort = standort;
        } else {
            this.standort = standort.stall;
        }
    }

    splitAufstalleinheit() {
        if (this.gruppe && this.gruppe.herdenname) {
            if (KieneUtils.brauchtAufstalleinheit(this.client)) {
                const parts = this.gruppe.herdenname.split('-AE-');
                if (parts && parts.length === 2) {
                    this.aufstalleinheitJahrCtrl.setValue(parts[0]);
                    this.aufstalleinheitNummerCtrl.setValue(parts[1]);
                }
            }
        }
    }

    loadClient() {
        if (this.gruppe.kunde_id) {
            this.api
                .getOne(this.apiBaseUrl + 'kunde/read_one.php', 'kunde_id', this.gruppe.kunde_id.toString())
                .subscribe(response => {
                    this.client = <Client>response;
                    if (KieneUtils.isApiOne(this.client.ohrmarke)) {
                        this.loadTiere();
                    }
                    this.splitAufstalleinheit();
                });
        }
    }

    loadTiere() {
        let params = new HttpParams().set('gruppe_id', this.gruppe.gruppe_id.toString());
        params = params.set('orderby', 'ohrmarke asc');
        params = params.set('limit', '1');
        params = params.set('offset', '0');

        this.api.get(this.apiBaseUrl + 'gruppe_tier/read.php', params).subscribe(
            response => {
                this.anzahlTiereOhrmarke = response.count;
            },
            error => {
                this.messageService.errorMessage(
                    'Die einzelnen Tiere für die Gruppe ' + this.gruppe.bezeichnung + ' konnten nicht geladen werden!',
                    error,
                );
            },
        );
    }

    private parseApiDate(value: Date | string): Date | null {
        if (!value) {
            return null;
        }
        const d = value instanceof Date ? value : new Date(value);
        return isNaN(d.getTime()) ? null : d;
    }

    /** MySQL DATE via API expects yyyy-MM-dd, not a JSON Date object. */
    private formatApiDate(value: Date | string): string | null {
        const d = this.parseApiDate(value);
        if (!d) {
            return null;
        }
        return formatDate(d, 'yyyy-MM-dd', 'de', 'Europe/Berlin');
    }

    save() {
        this.gruppe.bezeichnung = this.nameCtrl.value;
        this.gruppe.stall = this.standort;
        this.gruppe.einstalldatum_von = this.formatApiDate(this.einstalldatumVonCtrl.value);
        this.gruppe.einstalldatum_bis = this.formatApiDate(this.einstalldatumBisCtrl.value);

        if (KieneUtils.brauchtAufstalleinheit(this.client)) {
            this.gruppe.aufstalleinheit_jahr = this.aufstalleinheitJahrCtrl.value;
            this.gruppe.aufstalleinheit_nummer = this.aufstalleinheitNummerCtrl.value;
        }

        if (
            KieneUtils.isApiZero(this.client.tierbewegung_melden) ||
            (KieneUtils.isApiOne(this.client.tierbewegung_melden) &&
                (KieneUtils.isApiZero(this.client.ohrmarke) || this.anzahlTiereOhrmarke < 1))
        ) {
            this.gruppe.anzahl_tiere = this.anzahlTiereCtrl.value;
            this.gruppe.alter_bei_einstallung = this.alterEinstallungCtrl.value;
        }

        this.api.updateEntity(this.apiBaseUrl + 'gruppe/update.php', this.gruppe).subscribe({
            next: gruppe => {
                this.messageService.infoMessage('Änderung erfolgreich gespeichert!');
                this.dialogRef.close(gruppe);
            },
            error: error => {
                this.messageService.errorMessage('Änderung konnte nicht gespeichert werden!', error);
            },
        });
    }
}
